import { Component, Inject, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ShopWindowItem } from '../../model/shop-window-item';
import { SessionStorageService } from "../../services/session-storage.service";

@Component({
    selector: 'pme-suggestion-product-modal',
    templateUrl: './suggestion-product-modal.component.html',
    styleUrls: ['./suggestion-product-modal.component.scss'],
    standalone: false
})
export class SuggestionProductModalComponent implements OnInit {
  sameProduct: boolean;
  fullQuery: number;
  mediumQuery: number;
  fullValue: number;
  discountValue: number;
  colapsed: boolean = true;
  currentvalue: number;
  showFullValue: boolean;
  minutes: number = 2;
  seconds: number = 0;
  discountPercent: number;
  discountIdentifier: string;
  discountedValue: number;

  suggestionProductIdentifier: string;
  triggerProductIdentifier: string;

  discountedValueStr: string;
  currentvalueStr: number;
  discountValueStr: number;
  fullValueStr: number;
  
  features: Array<{
    name: string;
    current: string;
    new: string;
  }>;


  constructor(
    private sessionStorageService: SessionStorageService,
    public dialogRef: MatDialogRef<SuggestionProductModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { product: ShopWindowItem, sameProduct: boolean, suggestion: ShopWindowItem }) {
    this.sameProduct = data.sameProduct;

    this.fullQuery = data.suggestion.featureList.find(f => f.name === 'Consulta completa')?.requests;
    this.mediumQuery = data.suggestion.featureList.find(f => f.name === 'Consulta intermediária')?.requests;
    this.fullValue = data.suggestion.baseValue;
    this.discountValue = data.suggestion.totalValue;
    this.discountedValue = data.product.suggestion.discountedValue;
    this.currentvalue = data.product.totalValue;
    this.showFullValue = this.fullValue !== this.discountedValue;

    this.discountIdentifier = data.product.suggestion.discountIdentifier;
    this.discountPercent = data.product.suggestion.discountPercent;

    this.discountedValueStr = this.formatPrice(this.discountedValue);
    this.discountValueStr = this.formatPrice(this.discountValue);
    this.currentvalueStr = this.formatPrice(this.currentvalue);
    this.fullValueStr = this.formatPrice(this.fullValue);
    this.suggestionProductIdentifier = data.product.suggestion.suggestionProductIdentifier;

    this.features = data.product.featureList.reduce((acc, feature, i) => {
      acc.push({
        name: feature.name,
        current: (feature.toValue || feature.fromValue),
        new: (data?.suggestion?.featureList[i]?.toValue || data?.suggestion?.featureList[i]?.fromValue)
      });
      return acc;
    }, []);
    if (this.discountIdentifier) {
      this.startCountdown();
    }
  }

  ngOnDestroy(): void {
    this.minutes = 0;
    this.seconds = 0;
  }

  ngOnInit(): void {
  }

  setColapser(): void {
    this.colapsed = !this.colapsed;
  }

  clickCurrentButton(): void {
    this.dialogRef.close({
      approveSugestion: false
    });

  }

  clickUpButton(): void {
    if (this.discountIdentifier) {
      this.sessionStorageService.setCoupon(this.discountIdentifier);
    }
    this.dialogRef.close({
      approveSugestion: true
    });
  }

  clickCloseButton(): void {
    this.dialogRef.close();
  }

  startCountdown() {
    const countdown = setInterval(() => {
      if (this.seconds > 0) {
        this.seconds--;
      } else {
        if (this.minutes > 0) {
          this.minutes--;
          this.seconds = 59;
        } else {
          this.clickCloseButton();
          clearInterval(countdown);
        }
      }
      this.updateDisplay();
    }, 1000);
  }

  updateDisplay() {
    const minuteTensElement = document.getElementById('minute-tens');
    const minuteUnitsElement = document.getElementById('minute-units');
    const secondTensElement = document.getElementById('second-tens');
    const secondUnitsElement = document.getElementById('second-units');

    const minutesString = this.minutes < 10 ? '0' + this.minutes : this.minutes.toString();
    const secondsString = this.seconds < 10 ? '0' + this.seconds : this.seconds.toString();

    if (minuteTensElement && minuteUnitsElement && secondTensElement && secondUnitsElement) {
      minuteTensElement.textContent = minutesString[0];
      minuteUnitsElement.textContent = minutesString[1];
      secondTensElement.textContent = secondsString[0];
      secondUnitsElement.textContent = secondsString[1];
    }
  }

  formatPrice(price) {
    if (price % 1 === 0) {
      return price.toFixed(0);
    } else {
      return price.toFixed(2).replace('.', ',');
    }
  }
}
